module.exports = __webpack_public_path__ + "static/media/plusPlaceholder.10f08ade.png";